import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { incrementGlobalCounter } from './services/globalCounterService';
import Inicio from './components/Inicio/Inicio';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Transparencia from './components/Transparencia/Transparencia';
import Rubros from './components/Rubros/Rubros';
import DetalleRubro from './components/DetalleRubro/DetalleRubro';
import RubrosHistoricos from "./components/RubrosHistoricos/RubrosHistoricos";
import Agenda from "./components/Agenda/Agenda";
import Csii from "./components/Csii/Csii";
import Sustentable from "./components/Sustentable/Sustentable";
import Movilidad from "./components/Movilidad/Movilidad";
import Paaas from "./components/Paaas/Paaas";
import Directorio from "./components/Directorio/Directorio";
import Despacho from "./components/Despacho/Despacho";
import Quejas from "./components/Quejas/Quejas";
import Ligas from "./components/Ligas/Ligas";
import Popup from "./components/Pop up/pop_up";
import YoutubeCarousel from "./json/YoutubeCarousel";
import Error404 from "./components/Error404/Error404";
// ...otros imports...

function AppContent() {
  const celebrationMilestone = 30;
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const [showCelebration, setShowCelebration] = useState(false);
  const [visitCount, setVisitCount] = useState(0);

  useEffect(() => {
    if (location.pathname !== "/") {
      return;
    }

    setShowPopup(true);

    const updateCounter = async () => {
      try {
        const newCount = await incrementGlobalCounter();
        if (newCount !== null) {
          setVisitCount(newCount);
          if (newCount % celebrationMilestone === 0) {
            setShowCelebration(true);
            window.setTimeout(() => setShowCelebration(false), 6000);
          }
        } else {
          // Fallback local cuando no hay endpoint global configurado.
          const local = Number(localStorage.getItem('semot-local-counter')) || 0;
          const updated = local + 1;
          setVisitCount(updated);
          localStorage.setItem('semot-local-counter', String(updated));
        }
      } catch (error) {
        console.error('Error en contador:', error);
        const local = Number(localStorage.getItem('semot-local-counter')) || 0;
        setVisitCount(local);
      }
    };

    updateCounter();
  }, [location.pathname, celebrationMilestone]);

  return (
    <>
      <Header/>
      {location.pathname === "/" && (
        <Popup
          onClose={() => setShowPopup(false)}
          visible={showPopup}
          celebrationActive={showCelebration}
          visitCount={visitCount}
        />
      )}
      <Routes>
        <Route exact path="/" element={ <Inicio /> } />
        <Route exact path="/Transparencia" element={ <Transparencia/> } />
        <Route exact path="/Transparencia/Rubros" element={ <Rubros/> } />
        <Route exact path="/Transparencia/Rubros/DetalleRubro/:nombre" element={ <DetalleRubro/> } />
        <Route exact path="/Transparencia/Rubros/RubrosHistoricos" element={ <RubrosHistoricos/> } />
        <Route exact path="/Agenda" element={ <Agenda/> } />
        <Route exact path="/Csii" element={ <Csii/> } />
        <Route exact path="/Movilidad" element={ <Movilidad/> } />
        <Route exact path="/Paaas" element={ <Paaas/> } />
        <Route exact path="/Directorio" element={ <Directorio/> } />
        <Route exact path="/Despacho" element={ <Despacho/> } />
        <Route exact path="/YoutubeCarousel" element={ <YoutubeCarousel/> } />
        <Route exact path="/Sustentable" element={ <Sustentable/> } />
        <Route exact path="/Quejas" element={ <Quejas/> } />
        <Route exact path="/Ligas" element={ <Ligas/> } />
        <Route exact path="*" element={<Error404 /> } />
      </Routes>
      <Footer/>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;